import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

const StyledWrapper = styled.div`
  padding: 88px 20px;
  position: relative;
  text-align: center;

  ${({ overflow }) =>
    overflow &&
    css`
      overflow: hidden;
    `}

  ${({ extended }) =>
    extended &&
    css`
      background-color: #04162b;
    `}

    ${({ small }) =>
    small &&
    css`
      min-height: 0px;
      padding: 88px 0 0;
    `}

  ${({ theme }) => theme.media.desktop} {
    align-items: center;
    display: flex;
    justify-content: center;
    min-height: 576px;
    padding: 88px 0px;

    ${({ small }) =>
      small &&
      css`
        min-height: initial;
        padding: 88px 0
      `}
  }

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      ${StyledContainer} {
        ${({ theme }) => theme.media.desktop} {
          flex-wrap: nowrap;
          padding: 0;
        }
      }
    `}
`

const StyledContainer = styled.div`
  flex-wrap: wrap;
  padding: 0;
  width: 100%;

  ${({ centered }) =>
    centered &&
    css`
      align-items: center;
      display: flex;
      flex-direction: column;
    `}

  ${({ theme }) => theme.media.desktop} {
    flex-wrap: nowrap;
    padding: 0 calc(8.333333% - 24px);
  }
`
const GeneralSection = ({
  blueBG,
  centered,
  children,
  cmsData,
  fullWidth,
  noPadding,
  overflow,
  small,
}) => {
  return (
    <StyledWrapper
      blueBG={cmsData ? cmsData.blueBG : blueBG}
      fullWidth={fullWidth}
      noPadding={noPadding}
      overflow={overflow}
      small={cmsData ? cmsData.small : small}
    >
      <StyledContainer centered={centered}>{children}</StyledContainer>
    </StyledWrapper>
  )
}

GeneralSection.propTypes = {
  children: PropTypes.node.isRequired,
}
export default GeneralSection
